import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'

import ProductRepository from '@/shared/http/repositories/configurations/product.js'
import CardProductRepository from '@/shared/http/repositories/crm/cardproduct.js'

import ModalProductForm from './productmodal-form.js'
import { createNewFollowupWithCard } from '@/components/tools/FollowupTools.js'

const ModalProductModel = {
  id: null,
  cardId: null,
  produtoId: null,
  valor: '',
  operacao: '',
  diasAtraso: null,
  data: null,
  observacao: null
}

export default {
  name: 'ProductModal',
  mixins: [ActionsForm],
  props: {
    card: {
      type: Object,
      default: () => ({})
    },
    eventManager: {
      type: Object
    }
  },
  data () {
    return {
      personId: null,
      alreadyPerson: false,
      data: ModalProductModel,
      form: ModalProductForm,
      isEditing: false,
      product: null
    }
  },
  mounted () {
    this.onGetAllProduct()
  },
  methods: {
    onLoad () {},
    showModal (obj) {
      this.data.id = null
      this.form.valor.value = ''
      this.form.observacao.value = null
      this.form.produtoId.value = null
      this.form.operacao.value = null
      this.form.diasAtraso.value = null
      this.isEditing = false
      this.$refs['modal-product'].show()
      if (obj) {
        loading.push()
        this.data.id = obj.id
        this.form.valor.value = obj.valor
        this.form.observacao.value = obj.observacao
        this.form.produtoId.value = obj.produtoDTO.id
        this.form.operacao.value = obj.operacao
        this.form.diasAtraso.value = obj.diasAtraso
        this.isEditing = true
        loading.pop()
      }
    },
    hideModal () {
      this.$destroy()
    },
    aborted () {
      this.$emit('Abort')
    },
    onGetAllProduct () {
      loading.push()
      ProductRepository.GetAllActive()
        .then((response) => {
          this.form.produtoId.options = this.onResultDropdown(response, null, f => f.nome)
        })
        .catch(this.onException)
    },
    onFormatData () {
      if (this.data) {
        this.data.valor = this.form.valor.value ? this.form.valor.value.toFixed(2) : 0
        this.data.cardId = this.card.id
        this.data.data = this.moment().format('YYYY-MM-DD') + 'T' + this.moment().format('HH:mm:ss')
        this.data.observacao = this.form.observacao.value ? this.form.observacao.value : ''

        this.data.valor = this.form.valor.value || null
        this.data.operacao = this.form.operacao.value || null
        this.data.diasAtraso = this.form.diasAtraso.value || null
        this.data.produtoId = this.form.produtoId.value || null

        this.product = this.form.produtoId.options.find(x => x.value === this.data.produtoId)
      }
    },
    storeSubmit () {
      this.onFormatData()
      let submit = () => this.onCreate()
      this.$emit('Submit', submit)
      this.hideModal()
    },
    async onCreate () {
      if (!this.eventManager) this.onFormatData()

      await CardProductRepository.Create(this.data)
        .then((response) => {
          if (response.status === 200) {
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_adicionado', 'O Produto ' + this.product.text + ' foi cadastrado! ', this.ip, this.latitude, this.longitude, this.card.id)
            this.$emit('Reload')
            if (!this.eventManager) toast.success(this.$lang.Common.Alerts.Success)
            this.hideModal()
          }
          loading.pop()
        })
        .catch(error => {
          toast.error(error.data.errors ? error.data.errors[0].message : '', 'Não foi possível realizar a operação!')
        })
    },
    async onUpdate () {
      this.onFormatData()
      await CardProductRepository.Update(this.data)
        .then((response) => {
          if (response.status === 200) {
            let product = this.form.produtoId.options.find(x => x.value === this.data.produtoId)
            createNewFollowupWithCard(this.card.pessoa.document, 'sys_produto_editado', 'O Produto ' + product.text + ' foi atualizado!', this.ip, this.latitude, this.longitude, this.card.id)
            this.$emit('Reload')
            let fuckYeah = () => this.onCreate()
            this.$emit('Submit', fuckYeah)
            this.hideModal()
            toast.success(this.$lang.Common.Alerts.Success)
          }
          loading.pop()
        })
        .catch(this.onException)
    },
    checkTypeBoard (card) {
      if (card && card.boardColumn.board.tipoBoard === 'COBRANCA') {
        return true
      }
      return false
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/details/product/modal/productmodal.js